import type {
  ModalAvisoBloqueoProps,
  UseModalAvisoBloqueoReturn,
} from "./types";

const MENSAJES_USER_DATA = [
  "Se ha acabado el tiempo limite para hacer el pago.",
  "Comuniquese con su proveedor para reactivar su cuenta.",
] as const;

const MENSAJES_USUARIO_RUTA = [
  "Por razones de pago se ha bloqueado su cuenta.",
  "Comuniquese con su administrador para hacer la reactivacion.",
] as const;

const MENSAJES_VACIOS = [] as const;

export const useModalAvisoBloqueo = ({
  userData,
  usuarioRuta,
}: ModalAvisoBloqueoProps): UseModalAvisoBloqueoReturn => {
  if (userData) {
    return {
      mensajes: MENSAJES_USER_DATA,
    };
  }

  if (usuarioRuta) {
    return {
      mensajes: MENSAJES_USUARIO_RUTA,
    };
  }

  return {
    mensajes: MENSAJES_VACIOS,
  };
};
